<template>
  <el-row type="flex" justify="space-between" class="home-section margin-top_32">
    <div class="item">
      <a href="https://training.nrta.gov.cn/zt/sanzhong/learnSpecialIndex.html" target="_blank">
        <img src="../../../assets/image/advmap.jpg" class="image">
      </a>
    </div>
    <!-- <div class="item">
      <img src="" class="image">
    </div> -->
  </el-row>
</template>
<script>
export default {
  name: 'HomeSection5',

  data() {
    return {
      activeIndex: 1,
      infoList: [
        {}
      ]
    }
  },
  created() {
  },
  methods: {}
}
</script>
<style lang="scss" scoped>
.home-section {
  .item {
    width: 100%;
    height: auto;
    .image {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
